export default __webpack_public_path__ + "static/media/drupal.e2fbe595.svg";